import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { Row, Col, Menu, Icon, Spin, Modal, Button, Popover } from 'antd'
import Slider from "react-slick"
import { Link } from 'react-router-dom'
import randomColor from 'randomcolor'
import { app, api, config } from "../../app"
import logo_img from "../../assets/LOGO_1.png"
import NewsDetail from "../../components/NewsDetail"
import asyncComponent from "../../components/asyncComponent"

const BarReact = asyncComponent(() => import('../../components/BarEcharts'))  //柱形图组件

const MenuItem = Menu.Item

function loadNode() {
    return (<div className="load-example"><Spin size="large" /></div>)
}

function notNode(text) {
    return (
        <div className="no-data">
            <Icon type="info-circle" />
            <span className="no-data-text">{text}</span>
        </div>
    )
}

/**
 * 生成职能分布图配置参数
 */
function generatePPEChart(info = []) {
    let options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: {
            axisTick: {
                show: false,
            },
            axisLabel: {
                interval: 0,
                rotate: 40,
                color: '#888888',
                formatter: (value) => {
                    if (value.length > 6) {
                        return value.substr(0, 5) + '...'
                    }
                    return value
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dddddd'
                }
            },
            splitLine: {
                show: false
            },//去除网格线
            data: info.map(p => p.name)
        },
        yAxis: {
            show: false,
            minInterval: 1
        },
        series: [
            {
                name: '人数',
                type: 'bar',
                // barWidth: `${90 / info.length - 3}%`,
                itemStyle: {
                    normal: {
                        color: () => randomColor({ luminosity: 'light' })
                    }
                },
                data: info.map(p => parseInt(p.num || 0))
            }
        ]
    }
    return options
}

class Province extends Component {
    constructor(props) {
        super(props)
        this.state = {
            token: '',
            menu_key: ['information'],
            menus: [
                { key: 'information', name: props.match.params.province || '基本信息', content: null },
                { key: 'overview', name: '全省存心成员概况', content: null },
                { key: 'skill', name: '全省存心成员职能分布', content: null },
                { key: 'news', name: '新闻动态', content: null },
                { key: 'honorwall', name: '荣誉墙', content: null },
            ],
            info: {},
            data_loading: true,
            province: props.match.params.province,
            newsInfo: {},
            news_detail_visible: false,
            news_detail_loading: false,
            ppeChartData: {}
        }
    }

    async componentDidMount() {
        this._isMounted = true
        this.getTokeni();
        await this.dataSource()
    }

    /**
     * 数据源
     */
    dataSource = async () => {
        let { province } = this.state
        let { flag, data, msg } = await app.post(api.ProvinceTeamDetails, { province })
        let state = { data_loading: false }
        if (flag === 1) {
            state.info = data
            state.ppeChartData = generatePPEChart(data.ppe)
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
    * 获取token
    * @returns {Promise<void>}
    */
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                token: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 查看新闻详情
     * @param id
     */
    handleNewsDetail = async (id) => {
        await this.setData({ news_detail_visible: true, news_detail_loading: true })
        let state = { news_detail_loading: false }
        let { flag, data, msg } = await app.post(api.NewNewsDetails, {
            id,
            request: 'news',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            data.id = id
            state.newsInfo = data
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }


    setData = (data) => app.setStateSync(this, data)

    /**
     * 顶部导航栏点击
     */
    handleMenuClick = ({ key }) => {
        if (key) {
            let anchorElement = document.getElementById('mp-' + key)
            if (anchorElement) {
                anchorElement.scrollIntoView(true)
            }
        }
    }

    /**
     * 跳转队伍列表页面
     */
    handleToTeams = () => {
        this.props.history.push(`/ranks/pro/${this.state.province}`)
    }

    /**
     * 荣誉墙点击
     * @param honor
     */
    handleHonorClick = async (honor) => {
        Modal.info({
            title: '荣誉详情',
            okText: '确定',
            centered: true,
            width: '50vw',
            content: (
                <div style={{ padding: '20px 0' }}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉图片：</Col>
                        <Col span={14} offset={1}>
                            <div style={{ height: 120 }}>
                                <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                    src={config.imgUrl + honor.img} alt="" title={honor.name} />
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉名称：</Col>
                        <Col span={14} offset={1}>{honor.name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉类型：</Col>
                        <Col span={14} offset={1}>{honor.type_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉等级：</Col>
                        <Col span={14} offset={1}>{honor.category_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>获奖时间：</Col>
                        <Col span={14} offset={1}>{honor.date}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>备注信息：</Col>
                        <Col span={14} offset={1}><span>{honor.remark || ' - '}</span></Col>
                    </Row>
                </div>
            )
        })
    }

    render() {
        let { data_loading, info, menus, menu_key, newsInfo, news_detail_visible, news_detail_loading, province, ppeChartData, token } = this.state
        let carousel_settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
        let menu_nodes = []
        if (!data_loading) {
            menu_nodes = menus.map(m => {
                switch (m.key) {
                    case 'information':
                        m.content = (
                            <Row type="flex" justify="center" align="middle" className="tci-info tci-module">
                                <div className="t-logo">
                                    <img src={logo_img} alt="" />
                                </div>
                                <div className="t-info">
                                    <div className="ti-item">
                                        <span className="pi-title">品牌督导官：</span>
                                        <span className="pi-content">
                                            {info.schultheiss && info.schultheiss.indexno ? (
                                                <Link
                                                    to={`/player/00/${info.schultheiss.indexno}?token=${token}`}>{info.schultheiss.name}</Link>
                                            ) : ' - '}
                                        </span>
                                    </div>
                                    {/* <div className="ti-item">
                                        <span className="pi-title">省管理员：</span>
                                        <span className="pi-content">
                                            {info.province_admin && info.province_admin.length > 0 ? info.province_admin.map((pa, i) => {
                                                let ns = [(
                                                    <Link key={i + 1} to={`/player/00/${pa.indexno}?token=${token}`}>{pa.name}</Link>)]
                                                if (i < info.province_admin.length - 1) {
                                                    ns.push(<span key={i + 2}>、</span>)
                                                }
                                                return ns
                                            }) : ' - '}
                                        </span>
                                    </div> */}
                                </div>
                            </Row>
                        )
                        break
                    case 'overview':
                        let toItems = [
                            { name: '全省队伍数量', color: '#ED445B', point: 10, unit: '支', value: info.team_num || 0 },
                            { name: '全省存心男性成员', color: '#ED9529', point: 32, unit: '人', value: info.men_num || 0 },
                            { name: '全省年内救援次数', color: '#218BF9', point: 48, unit: '次', value: info.rescue_num || 0 },
                            { name: '全省年内培训次数', color: '#3CAAB9', point: 64, unit: '次', value: info.train_num || 0 },
                        ]
                        let boItems = [
                            {
                                name: '全省存心男女比例',
                                color: '#FA6022',
                                point: 10,
                                unit: '',
                                value: info.proportion_sex || ' - '
                            },
                            { name: '全省存心女性成员', color: '#F167A5', point: 26, unit: '人', value: info.women_num || 0 },
                            {
                                name: '全省上年救援次数',
                                color: '#30A85E',
                                point: 42,
                                unit: '次',
                                value: info.rescue_num_last || 0
                            },
                            {
                                name: '全省上年培训次数',
                                color: '#2D90D3',
                                point: 58,
                                unit: '次',
                                value: info.train_num_last || 0
                            },
                        ]
                        m.content = (
                            <Row type="flex" align="middle" className="tci-overview">
                                {/*<div className="to-inter">*/}
                                <div className="to-item to-item-left">
                                    <div>全省存心总人数</div>
                                    <div><b className="to-num">{info.volunteer_num || 0}</b>人</div>
                                </div>
                                {/*</div>*/}
                                <div className="to-point">
                                    <div className="to-top">
                                        {
                                            toItems.map((ti, i) => {
                                                return (
                                                    <div key={i} className="to-item"
                                                        style={{ left: `calc(${i * 20}% + ${ti.point}px)` }}>
                                                        <div>{ti.name}</div>
                                                        <div><b style={{ color: ti.color }}
                                                            className="to-num">{ti.value}</b>{ti.unit}</div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="to-line">
                                        {
                                            [1, 2, 3, 4, 5, 6, 7, 8].map(p => {
                                                if (p === 1) {
                                                    return (
                                                        <div key={p} style={{ left: `${p * 10}%` }}
                                                            className="tol-point" />
                                                    )
                                                } else {
                                                    return (
                                                        <div key={p} style={{ left: `calc(${p * 10}% + ${p * 8}px)` }}
                                                            className="tol-point" />
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                    <div className="to-bottom">
                                        {
                                            boItems.map((ti, i) => {
                                                return (
                                                    <div key={i} className="to-item"
                                                        style={{ left: `calc(${i * 20 + 12}% + ${ti.point}px)` }}>
                                                        <div>{ti.name}</div>
                                                        <div><b style={{ color: ti.color }}
                                                            className="to-num">{ti.value}</b>{ti.unit}</div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Row>
                        )
                        break
                    case 'honorwall':
                        m.content = (
                            <div className="tci-honor">
                                <Slider {...carousel_settings}>
                                    {
                                        info.honor && info.honor.length > 0 ? info.honor.map((m, i) => {
                                            return (
                                                <div key={i} className="pe-item" title={m.name}
                                                    onClick={() => this.handleHonorClick(m)}>
                                                    <div className="pei-img" style={{ cursor: 'pointer' }}>
                                                        <img src={config.imgUrl + m.img} alt="荣誉图片" />
                                                    </div>
                                                    <div className="pei-name" title={m.name}>
                                                        {m.name}
                                                    </div>
                                                </div>
                                            )
                                        }) : notNode('暂无荣誉信息')
                                    }
                                </Slider>
                                {
                                    info.honor && info.honor.length >= 15 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/phonorwall/' + province}>
                                                <span className="more-link-text">更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break
                    case 'skill':
                        m.content = (
                            <div className="tci-skill">
                                <BarReact option={ppeChartData} height={300} />
                                <div className="ts-btns">
                                    <Button type="primary" icon="team"
                                        onClick={() => this.handleToTeams()}>省内队伍列表</Button>
                                </div>
                            </div>
                        )
                        break
                    case 'news':
                        m.content = (
                            <div className="tci-news tci-module">
                                {
                                    info.news && info.news.length > 0 ? info.news.map(item => {
                                        return (<div className="tn-item" key={item.id}
                                            onClick={() => this.handleNewsDetail(item.id)}
                                        >
                                            <div className="tn-img">
                                                <img src={config.imgUrl + item.news_img} alt="" />
                                            </div>
                                            <div className="tn-info">
                                                <div className="tn-title">{item.news_title}</div>
                                                <div className="tn-date">
                                                    <span>{item.release_time}</span>
                                                    <div className="tn-icon">
                                                        <span>
                                                            <i className="iconfont icon-yuedu" style={{ fontSize: '.6rem' }} />
                                                            <span style={{ padding: '0 .25rem' }}>{item.hits || 0}</span>
                                                        </span>
                                                        <Popover placement="right" title="手机扫码分享" content={
                                                            <QRCode value={config.shareDoman + item.id} />
                                                        } overlayStyle={{ textAlign: 'center' }}>
                                                            <span style={{ marginLeft: '.25rem' }}>
                                                                <i className="iconfont icon-fenxiang"
                                                                    style={{
                                                                        fontSize: '.6rem',
                                                                        color: '#5E92B4'
                                                                    }} />
                                                                <span style={{ padding: '0 .25rem' }}>分享</span>
                                                            </span>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)
                                    }) : notNode('暂无新闻')
                                }
                                {
                                    info.news && info.news.length >= 4 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/pnews/' + province}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break

                }
                return m
            })
        }
        return (
            <div className="team-page">
                <Menu mode="horizontal" className="tp-menu" defaultSelectedKeys={menu_key}
                    onClick={this.handleMenuClick}>
                    {
                        menus.map(m => {
                            return (
                                <MenuItem key={m.key}>{m.name}</MenuItem>
                            )
                        })
                    }
                </Menu>
                <div className="tp-scroll">
                    <div className="tps-content">
                        <div style={{ textAlign: 'right', paddingTop: 10 }}>
                            <Button icon="rollback" onClick={() => app.backPage(this)}>返回</Button>
                        </div>
                        {
                            data_loading ? loadNode() : menu_nodes.map((m, i) => {
                                return (
                                    <div key={i} className="tc-item" id={'mp-' + m.key}>
                                        <div className="tci-title">{m.name}</div>
                                        <div className="tci-content">
                                            {m.content}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <Modal
                    visible={news_detail_visible}
                    footer={null}
                    title="新闻详情"
                    maskClosable={false}
                    width='100%'
                    style={{ top: 0, height: '100vh' }}
                    bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                    onCancel={() => this.setData({ news_detail_visible: false })}
                    zIndex={2999}
                    className="news-detail-modal-class"
                >
                    <NewsDetail data={newsInfo} loading={news_detail_loading} />
                </Modal>
            </div>
        )
    }
}

export default Province



// WEBPACK FOOTER //
// ./src/routes/ranks/Province.jsx